import { render, staticRenderFns } from "./AddPersonToInstitutionModal.vue?vue&type=template&id=15b489f8&scoped=true&"
import script from "./AddPersonToInstitutionModal.vue?vue&type=script&lang=js&"
export * from "./AddPersonToInstitutionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPersonToInstitutionModal.vue?vue&type=style&index=0&id=15b489f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b489f8",
  null
  
)

export default component.exports